import { SensibleNumber } from '../../common/SensibleNumber'
import { Injector } from '../../injector'
import { CashierService } from '../../services/CashierService'
import { getStore } from '../Store'
import { preventDuplicateRequest } from '../ReduxUtils'

export enum CashoutActionType {
    SET_AMOUNT = 'SET_CASHOUT_AMOUNT',
    RECEIVE_CASHOUT_INFO = 'RECEIVE_CASHOUT_INFO',
    SUBMIT_CASHOUT = 'SUBMIT_CASHOUT',
    RECEIVE_CASHOUT_RESPONSE = 'RECEIVE_CASHOUT_RESPONSE',
    RECEIVE_PURCHASE_COUNTERS = 'RECEIVE_CASHOUT_PURCHASE_COUNTERS',
    RESET_STATE = 'RESET_CASHOUT_STATE',
    START_PRIZEOUT_REDEMPTION = 'START_PRIZEOUT_REDEMPTION',
}

interface SetCashoutAmount {
    type: typeof CashoutActionType.SET_AMOUNT;
    payload: SensibleNumber;
}

interface ReceiveCashoutInfo {
    type: typeof CashoutActionType.RECEIVE_CASHOUT_INFO;
    payload: UserCashoutInfo;
}

interface SubmitCashout {
    type: typeof CashoutActionType.SUBMIT_CASHOUT;
    payload?: undefined;
}

interface ReceiveCashoutResponse {
    type: typeof CashoutActionType.RECEIVE_CASHOUT_RESPONSE;
    payload: boolean; // Success/fail
}

interface ReceivePurchaseCounters {
    type: typeof CashoutActionType.RECEIVE_PURCHASE_COUNTERS;
    payload: { [key: string]: string };
}

interface ResetState {
    type: typeof CashoutActionType.RESET_STATE;
    payload?: undefined
}

interface StartPrizeoutRedemption {
    type: typeof CashoutActionType.START_PRIZEOUT_REDEMPTION;
    payload?: undefined;
}

export type CashoutAction =
    | SetCashoutAmount
    | ReceiveCashoutInfo
    | SubmitCashout
    | ReceiveCashoutResponse
    | ReceivePurchaseCounters
    | ResetState
    | StartPrizeoutRedemption;

export function dispatchCashoutAction(action: CashoutAction) {
	getStore().dispatch(action)
}

// Action helpers below

export function resetCashoutState(): void {
	dispatchCashoutAction({ type: CashoutActionType.RESET_STATE })
}

export const fetchUserCashoutInfo = preventDuplicateRequest(() => {
	return Injector.get(CashierService)
		.getCashoutInfo()
		.then(info => {
			dispatchCashoutAction({ type: CashoutActionType.RECEIVE_CASHOUT_INFO, payload: info })
		})
})

export function receiveCashoutResponse(isSuccessful: boolean): void {
	dispatchCashoutAction({ type: CashoutActionType.RECEIVE_CASHOUT_RESPONSE, payload: isSuccessful })
}
